module.exports = __webpack_public_path__ + "img/live-other.7dae3cab.gif";